/**
 * Shared Pusher channel for isg-channel – used by UtilContext (notifications) and
 * progressive lists (checklist_record.*, maintenance_record.*, …).
 * Single connection, single channel, multiple event bindings.
 */
import Pusher from 'pusher-js';

const PUSHER_KEY = '798100b9a135677e9c73';
const PUSHER_CLUSTER = 'eu';
const CHANNEL_NAME = 'isg-channel';

let pusherInstance = null;
let channelInstance = null;

export function getPusherChannel() {
  if (!channelInstance) {
    pusherInstance = new Pusher(PUSHER_KEY, { cluster: PUSHER_CLUSTER });
    channelInstance = pusherInstance.subscribe(CHANNEL_NAME);
  }
  return channelInstance;
}

/** Call when nothing needs Pusher anymore (e.g. logout). UtilContext handles disconnect. */
export function disconnectPusher() {
  if (pusherInstance) {
    pusherInstance.disconnect();
    pusherInstance = null;
    channelInstance = null;
  }
}
